import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { GetAllAwardsDocument, RemoveAwardDocument, CreateAwardDocument, UpdateAwardsDocument, SearchAwardsDocument } from './schema.graphql';
import { GetAllAwardsQueryVariables, GetAllAwardsQuery, RemoveAwardMutation, RemoveAwardMutationVariable, CreateAwardMutation, CreateAwardMutationVariable, UpdateAwardMutation, UpdateAwardMutationVariable, SearchAwardsQuery, SearchAwardsQueryVariables  } from 'src/app/model/award';

@Injectable({
  providedIn: 'root'
})
export class GetAllAwardsGQL extends Apollo.Query<GetAllAwardsQuery, GetAllAwardsQueryVariables>{
  document = GetAllAwardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})
export class RemoveAwardGQL extends Apollo.Mutation<RemoveAwardMutation, RemoveAwardMutationVariable>{
  document = RemoveAwardDocument;

  constructor(apollo: Apollo.Apollo){
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CreateAwardGQL extends Apollo.Mutation<CreateAwardMutation, CreateAwardMutationVariable>{
  document = CreateAwardDocument;

  constructor(apollo: Apollo.Apollo){
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})
export class UpdateAwardsGQL extends Apollo.Mutation<UpdateAwardMutation, UpdateAwardMutationVariable>{
  document = UpdateAwardsDocument;

  constructor(apollo: Apollo.Apollo){
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SearchAwardGQL extends Apollo.Query<SearchAwardsQuery, SearchAwardsQueryVariables> {
  document = SearchAwardsDocument;
  
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
